export const TableHook = {
  mounted() {
    this.pendingFilterOptions = new Set();
    this.onFilterClick = (event) => selectFilter(event, this);
    this.onRestoreFilter = (event) => restoreFilter(event.detail.name, this);
    this.el.addEventListener("click", this.onFilterClick);
    this.el.addEventListener("phenix:restore-table-filter", this.onRestoreFilter);
    renderTable(this.el, this);
  },
  updated() {
    renderTable(this.el, this);
  },
  destroyed() {
    this.el.removeEventListener("click", this.onFilterClick);
    this.el.removeEventListener("phenix:restore-table-filter", this.onRestoreFilter);
  },
};

function tablesInView(view) {
  return Array.from(view.querySelectorAll("[data-table-wrapper]")).filter(
    (table) => table.closest("[data-phx-session]") === view,
  );
}

function filterMenu(table, name) {
  return Array.from(table.querySelectorAll("[data-table-filter-menu]")).find(
    (menu) => menu.dataset.tableFilterMenu === name,
  );
}

function selectFilter(event, hook) {
  const option = event.target.closest("a[phx-value-action]");
  if (!option || !option.closest("[data-table-filter-menu]") || !hook.el.contains(option)) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  const name = option.getAttribute("phx-value-attribute");
  const eventName = option.getAttribute("phx-click");
  const payload = { action: option.getAttribute("phx-value-action"), attribute: name };
  if (option.hasAttribute("phx-value-option")) {
    payload.option = option.getAttribute("phx-value-option");
  }
  const requestKey = JSON.stringify([name, payload.option ?? null]);
  if (hook.pendingFilterOptions.has(requestKey)) return;
  hook.pendingFilterOptions.add(requestKey);

  const view = hook.el.closest("[data-phx-session]");
  const tables = tablesInView(view);
  const index = tables.indexOf(hook.el);

  // The caller may replace both the table and its scroll container. Track its
  // position in the owning LiveView rather than relying on its versioned ID.
  const currentTable = () => {
    if (!view.isConnected) return null;
    const currentTables = tablesInView(view);
    return currentTables.length === tables.length ? currentTables[index] : null;
  };
  let cancelled = false;
  const cancelOnOutsideClick = (click) => {
    const table = currentTable();
    const menu = table && filterMenu(table, name);
    if (
      !menu?.contains(click.target) ||
      click.target.closest('[phx-click="close_filter_dropdown"]')
    ) {
      cancelled = true;
    }
  };

  document.addEventListener("click", cancelOnOutsideClick, true);
  hook
    .pushEvent(eventName, payload)
    .then(() => {
      const table = currentTable();
      const menu = table && filterMenu(table, name);
      if (cancelled || !menu || !menu.classList.contains("hidden")) return;
      table.dispatchEvent(new CustomEvent("phenix:restore-table-filter", { detail: { name } }));
    })
    .catch(() => {
      // A failed request must not reopen a menu after navigation or disconnect.
    })
    .finally(() => {
      hook.pendingFilterOptions.delete(requestKey);
      document.removeEventListener("click", cancelOnOutsideClick, true);
    });
}

function restoreFilter(name, hook) {
  const menu = filterMenu(hook.el, name);
  const trigger = Array.from(hook.el.querySelectorAll('[phx-click="open_filter_dropdown"]')).find(
    (icon) => icon.getAttribute("phx-value-name") === name,
  );
  if (!menu || !trigger) return;

  // Show the freshly rendered options before the next paint, then synchronize
  // the replacement component so subsequent server renders keep the menu open.
  menu.classList.replace("hidden", "contents");
  hook
    .pushEventTo(trigger.getAttribute("phx-target"), "open_filter_dropdown", { name })
    .then((results) => {
      if (results.length === 0 || results.some((result) => result.status === "rejected")) {
        menu.classList.replace("contents", "hidden");
      }
    });
}

function renderTable(el, hook) {
  for (const input of el.querySelectorAll("input[type='checkbox']")) {
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Input/checkbox#indeterminate_state_checkboxes.
    input.indeterminate = "indeterminate" in input.dataset;
  }

  const phxRowHoverEvent = el.dataset.phxRowHoverEvent;

  if (phxRowHoverEvent) {
    $("tbody tr", el).hover(
      (event) => {
        const id = $(event.target).closest("tr").attr("id");
        if (id) {
          hook.pushEvent(`${phxRowHoverEvent}-enter`, id);
        }
      },
      (event) => {
        const id = $(event.target).closest("tr").attr("id");
        if (id) {
          hook.pushEvent(`${phxRowHoverEvent}-leave`, id);
        }
      },
    );
  }
}
